export const CREATE_NEW_INTERACTION = 'CREATE_NEW_INTERACTION';
export const ADD_FILE = 'ADD_FILE';
export const REMOVE_FILE = 'REMOVE_FILE';
export const SELECT_TEMPLATE = 'SELECT_TEMPLATE';
export const CHANGE_EDITOR_STATE = 'CHANGE_EDITOR_STATE';
export const CHANGE_FIELD = 'CHANGE_FIELD';
export const SEND_NOTE_START = 'SEND_NOTE_START';
export const SEND_NOTE_SUCCESS = 'SEND_NOTE_SUCCESS';
export const SEND_EMAIL_START = 'SEND_EMAIL_START';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR';
export const CHANGE_EMAIL_SUBJECT_EDITOR_STATE = 'CHANGE_EMAIL_SUBJECT_EDITOR_STATE';
export const SEND_LETTER_START = 'SEND_LETTER_START';
export const SEND_LETTER_SUCCESS = 'SEND_LETTER_SUCCESS';
export const SEND_EBOKS_START = 'SEND_EBOKS_START';
export const SEND_EBOKS_SUCCESS = 'SEND_EBOKS_SUCCESS';
export const CHANGE_EBOKS_SUBJECT_EDITOR_STATE = 'CHANGE_EBOKS_SUBJECT_EDITOR_STATE';
export const REGISTER_CALL_START = 'REGISTER_CALL_START';
export const REGISTER_CALL_SUCCESS = 'REGISTER_CALL_SUCCESS';
export const SEND_SMS_START = 'SEND_SMS_START';
export const SEND_SMS_SUCCESS = 'SEND_SMS_SUCCESS';
export const REGISTER_AUTO_CALL_START = 'REGISTER_AUTO_CALL_START';
export const REGISTER_AUTO_CALL_SUCCESS = 'REGISTER_AUTO_CALL_SUCCESS';
export const CHANGE_SENDER = 'CHANGE_SENDER';
//# sourceMappingURL=actionTypes.js.map